/* DON'T EDIT THIS FILE: edit original and run build again */ export abstract class AttachmentFile {
  abstract store(storagePath: string, metadata: any): Promise<void>;
  abstract getOriginalName(): string;
}
